import loadable from "@loadable/component";

const CrowdSignalLegacy = loadable(() => import("./CrowdSignalLegacy.component"));
const FacebookLegacy = loadable(() => import("./FacebookLegacy.component"));
const GenericResponsiveLegacy = loadable(() => import("./GenericResponsiveLegacy.component"));
const GenericStaticLegacy = loadable(() => import("./GenericStaticLegacy.component"));
const IheartRadioLegacy = loadable(() => import("./IheartRadioLegacy.component"));
const ImgurLegacy = loadable(() => import("./ImgurLegacy.component"));
const InstagramLegacy = loadable(() => import("./InstagramLegacy.component"));
const SoundcloudLegacy = loadable(() => import("./SoundcloudLegacy.component"));
const TwitterLegacy = loadable(() => import("./TwitterLegacy.component"));
const YoutubeLegacy = loadable(() => import("./YoutubeLegacy.component"));
const PandaLegacy = loadable(() => import("./PandaLegacy.component"));

export {
    CrowdSignalLegacy,
    FacebookLegacy,
    GenericResponsiveLegacy,
    GenericStaticLegacy,
    IheartRadioLegacy,
    ImgurLegacy,
    InstagramLegacy,
    SoundcloudLegacy,
    TwitterLegacy,
    YoutubeLegacy,
    PandaLegacy,
};
